export default __webpack_public_path__ + "static/media/check.cbf2ade1.png";